import context, { IAppUserContext, AsyncComponentLoading, AsyncComponentError } from '@truckdown/components-systems';
import { defineAsyncComponent } from 'vue';
import { IInitializer, IUserContext } from "@truckdown/systems";

class ComponentInitializer implements IInitializer {
    name: string = 'LoggingComponentInitializer';
    order: number = 0;

    initialize(context: IUserContext): Promise<void> {
        console.log('Running Logging Component Initializer from App.Systems');

        let app = (context as IAppUserContext).app;

        app.component('instance-group', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-systems-instance-group" */ './InstanceGroup/InstanceGroup.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('instance-list', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-systems-instance-list" */ './InstanceList/InstanceList.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('instance-search', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-systems-instance-search" */ './InstanceSearch/InstanceSearch.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('context-list', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-systems-context-list" */ './ContextList/ContextList.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('context-search', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-systems-context-search" */ './ContextSearch/ContextSearch.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('log-entry-list', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-systems-log-entry-list" */ './LogEntryList/LogEntryList.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('log-search', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-systems-log-search" */ './LogEntrySearch/LogEntrySearch.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('instance', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-systems-instance" */ './Instance/Instance.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('context', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-systems-context" */ './Context/Context.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('log', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-systems-log" */ './LogEntry/LogEntry.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        app.component('exception', defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "app-systems-exception" */ './ExceptionView/ExceptionView.vue'),
            loadingComponent: AsyncComponentLoading,
            errorComponent: AsyncComponentError,
            delay: 200, //default 200 - does not work
            timeout: 3000, //default 3000 - Infinity
            suspensible: false
        }));

        return new Promise((resolve) => { resolve(); });
    }
}

context.registerService({
    name: 'IInitializer',
    activator: async () => {
        return new ComponentInitializer();
    }
});
